import { render, staticRenderFns } from "./CandidateRegistration.vue?vue&type=template&id=14f4b86a&scoped=true"
import script from "./CandidateRegistration.vue?vue&type=script&lang=js"
export * from "./CandidateRegistration.vue?vue&type=script&lang=js"
import style0 from "./CandidateRegistration.vue?vue&type=style&index=0&id=14f4b86a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "14f4b86a",
  null
  
)

export default component.exports